import { render, staticRenderFns } from "./SettingsShipping.vue?vue&type=template&id=d5663d0e&scoped=true"
import script from "./SettingsShipping.vue?vue&type=script&lang=js"
export * from "./SettingsShipping.vue?vue&type=script&lang=js"
import style0 from "./SettingsShipping.vue?vue&type=style&index=0&id=d5663d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5663d0e",
  null
  
)

export default component.exports